'use client';

import { useEffect, useState } from 'react';

import { HOME_SCREEN_APP_ENABLED } from '@/lib/env';
import {
  installPlatformOf,
  isStandaloneDisplay,
  type OfferPlatform,
} from '@/lib/install-platform';

// Read after mount only: the server render and hydration know neither the
// browser nor the display mode, and a crawler must never see the offer.
export const useInstallPlatform = () => {
  const [platform, setPlatform] = useState<OfferPlatform | null>(null);

  useEffect(() => {
    if (!HOME_SCREEN_APP_ENABLED || isStandaloneDisplay()) return;
    const device = installPlatformOf(
      navigator.userAgent,
      navigator.maxTouchPoints
    );
    if (device !== 'unsupported') setPlatform(device);
  }, []);

  return platform;
};
